/** @jsx h */
import { h } from 'preact'

import t from '../../../../utils/translate'

const Attribution = () => (
  <p class='HintUI u-marginTop8'>{t('proof_points.js.recycling.attribution')}</p>
)

export default Attribution
